import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import { getHolidays } from "../api/holidays.api";
import { queryKeys } from "../api/query-keys";

export interface UseHolidaysParams {
  startDate: Date | string;
  endDate: Date | string;
}

export function useHolidays({ startDate, endDate }: UseHolidaysParams) {
  const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
  const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");
  return useQuery({
    queryKey: queryKeys.holidays.range(formattedStartDate, formattedEndDate),
    queryFn: () =>
      getHolidays({
        startDate: formattedStartDate,
        endDate: formattedEndDate,
      }),
  });
}
